/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/href-no-hash */
import React, { PureComponent } from 'react';
import {
  Icon,
  Image,
  Button,
  Popup,
  Divider,
  Grid,
  Form,
  Card,
  Dimmer,
  Segment,
  Header,
  Label
} from 'semantic-ui-react';
import Images from '../../../assets/Images';
import './AdPrototypeList.css';

class AdPrototypeListCard extends PureComponent {
  state = {
    currentThumbnail: '',
    activeDimmer: false,
    prototypeInLaunchQueue: false
  };

  componentDidMount() {
    const { adLaunchQueue, adPrototype } = this.props;
    this.initializeInLaunchQueueState(adLaunchQueue, adPrototype);
    this.setCurrentThumbnailState(adPrototype.thumbnail);
  }

  componentWillReceiveProps() {
    const { adPrototype } = this.props;
    this.setCurrentThumbnailState(adPrototype.thumbnail);
  }

  componentDidUpdate(prevProps) {
    const { adLaunchQueue: prevAdLaunchQueue } = prevProps;
    const { adLaunchQueue, adPrototype } = this.props;
    const { length: prevQueueLength } = prevAdLaunchQueue || [];
    const { length: queueLength } = adLaunchQueue || [];

    if (prevQueueLength !== 0 && queueLength === 0) {
      this.initializeInLaunchQueueState([], adPrototype);
    }

    this.setCurrentThumbnailState(adPrototype.thumbnail);
  }

  setCurrentThumbnailState = (thumbnail) => {
    this.setState((prevState) => ({
      ...prevState,
      currentThumbnail: thumbnail
    }));
  };

  initializeInLaunchQueueState = (adLaunchQueue, adPrototypeToCompare) => {
    const { id } = adPrototypeToCompare;
    const foundPrototypeInQueue = adLaunchQueue.find(
      (adPrototype) => adPrototype.id === id
    );
    this.setState((prevState) => ({
      ...prevState,
      prototypeInLaunchQueue: !!foundPrototypeInQueue
    }));
  };

  toggleShowDimmer = (toggleValue) => {
    this.setState((prevState) => ({ ...prevState, activeDimmer: toggleValue }));
  };

  alterAdLaunchQueue = (adPrototypeId, addToQueue = false) => {
    const { alterAdLaunchQueue } = this.props;
    if (alterAdLaunchQueue) {
      alterAdLaunchQueue(adPrototypeId, addToQueue);
    }
    this.setState((prevState) => ({
      ...prevState,
      prototypeInLaunchQueue: addToQueue
    }));
  };

  renderAdPrototypeCard = () => {
    const { adPrototype, openDialog } = this.props;
    const { id } = adPrototype;
    const { prototypeInLaunchQueue } = this.state;
    return (
      <Card
        raised={!prototypeInLaunchQueue}
        style={prototypeInLaunchQueue ? { border: '0.3em solid #21ba45' } : {}}
      >
        <Card.Header>
          <div style={{ float: 'right' }}>
            <Button
              compact
              style={{ background: 'none' }}
              disabled={prototypeInLaunchQueue}
              onClick={() => openDialog(id)}
            >
              <Icon size="large" name="cancel" color="red" />
            </Button>
          </div>
        </Card.Header>
        {this.renderAdPrototypeCardDimmer(adPrototype)}
        <Card.Content extra>
          {this.renderAdProtypeActionButtons(adPrototype)}
        </Card.Content>
      </Card>
    );
  };

  renderAdPrototypeCardDimmer = (adPrototype) => {
    const { isLaunchQueueFull, renderTags } = this.props;
    const { id, type, name, thumbnail, qc_approved: qcApproved } = adPrototype;
    const {
      activeDimmer,
      prototypeInLaunchQueue,
      currentThumbnail
    } = this.state;
    const imageStyle =
      typeof qcApproved === 'boolean'
        ? { opacity: qcApproved ? 1.0 : 0.5 }
        : {};
    return (
      <Dimmer.Dimmable
        blurring
        dimmed={activeDimmer}
        onMouseEnter={() => this.toggleShowDimmer(true)}
        onMouseLeave={() => this.toggleShowDimmer(false)}
      >
        <Segment basic style={{ padding: 0, margin: 0 }}>
          <Image
            className="ad-prototype-thumbnail"
            style={imageStyle}
            src={
              type !== 'DAA'
                ? currentThumbnail || thumbnail
                : Images.daaTypeCard
            }
          />
        </Segment>
        <Card.Content>
          <Card.Header
            style={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden'
            }}
          >
            <Popup
              trigger={
                <span>
                  <b>{name}</b>
                </span>
              }
              on="hover"
              content={name}
            />
          </Card.Header>
          <Card.Meta>
            <span>
              <b>{type}</b>
            </span>
          </Card.Meta>
          <Card.Description>
            <br />
            {renderTags(adPrototype)}
            <br />
          </Card.Description>
        </Card.Content>
        <Dimmer active={activeDimmer}>
          <Header as="h4" inverted>
            {!prototypeInLaunchQueue
              ? 'Add prototype to launch queue'
              : 'Remove prototype from launch queue'}
          </Header>
          {!prototypeInLaunchQueue ? (
            <Button
              primary
              icon="plus"
              disabled={
                prototypeInLaunchQueue || isLaunchQueueFull || !qcApproved
              }
              onClick={() => this.alterAdLaunchQueue(id, true)}
            />
          ) : (
            <Button
              icon="minus"
              color="red"
              disabled={!prototypeInLaunchQueue}
              onClick={() => this.alterAdLaunchQueue(id, false)}
            />
          )}
        </Dimmer>
      </Dimmer.Dimmable>
    );
  };

  renderAdProtypeActionButtons = (adPrototype) => {
    const {
      editAdPrototype,
      launchAdPrototype,
      handleOpen,
      isOpen,
      errorMessage,
      copyAdName,
      handleNameChange,
      copyAdPrototype,
      handleClose,
      toggleAdBuilderAdPreviewModal,
      multiAdLaunchEnabled
    } = this.props;
    const { qc_approved: qcApproved } = adPrototype;
    return (
      <div>
        <div style={{ float: 'left' }}>
          {typeof qcApproved === 'boolean' ? (
            <Label
              size="small"
              color={qcApproved ? 'green' : 'red'}
              content={qcApproved ? 'Approved' : 'Denied'}
              icon="circle check outline"
            />
          ) : (
            <Label size="small" content="No status" icon="circle outline" />
          )}
        </div>
        <div style={{ float: 'right' }}>
          <a
            role="button"
            tabIndex={0}
            onClick={() => toggleAdBuilderAdPreviewModal(adPrototype)}
          >
            <Icon size="large" name="eye" />
          </a>
          <Popup
            wide
            trigger={
              <a
                role="button"
                tabIndex={0}
                onClick={() => handleOpen(adPrototype)}
              >
                <Icon size="large" name="copy outline" />
              </a>
            }
            on="click"
            open={isOpen === adPrototype.id}
          >
            {errorMessage ? (
              <div>
                <span className="ad-prototype-builder-error">
                  {errorMessage}
                </span>
                <Divider hidden />
              </div>
            ) : null}
            <Grid divided columns="equal">
              <Grid.Row>
                <Grid.Column>
                  <Form.Input
                    placeholder="Ad Name"
                    type="text"
                    name="copyAdName"
                    value={copyAdName}
                    onChange={handleNameChange}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Button
                    color="blue"
                    content="Confirm"
                    fluid
                    onClick={() => copyAdPrototype(adPrototype)}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Button
                    color="red"
                    content="Cancel"
                    fluid
                    onClick={() => handleClose()}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Popup>
          <a
            role="button"
            tabIndex={0}
            onClick={() => editAdPrototype(adPrototype)}
          >
            <Icon size="large" name="edit" />
          </a>
          {!multiAdLaunchEnabled ? (
            <a
              role="button"
              tabIndex={0}
              onClick={() => launchAdPrototype(adPrototype)}
            >
              <Icon size="large" name="external alternate" />
            </a>
          ) : null}
        </div>
      </div>
    );
  };

  renderConfirmDeleteCardComponent = (adPrototypeName) => {
    const { removeAdPrototype, handleCancel } = this.props;
    return (
      <Card>
        <Card.Content>
          <div>
            <p>
              Are you sure you want to delete <br />
              <i>{adPrototypeName}</i>?
            </p>
            <Button
              onClick={() => removeAdPrototype()}
              size="mini"
              color="grey"
            >
              Yes
            </Button>
            <Button onClick={handleCancel} size="mini" color="red">
              No
            </Button>
          </div>
        </Card.Content>
      </Card>
    );
  };

  render() {
    const { adPrototype, showConfirm, deleteRowId } = this.props;
    const { id: adPrototypeId, name: adPrototypeName } = adPrototype;
    return (
      <div style={{ margin: '0.5em' }}>
        {showConfirm && adPrototypeId === deleteRowId
          ? this.renderConfirmDeleteCardComponent(adPrototypeName)
          : this.renderAdPrototypeCard()}
      </div>
    );
  }
}

export default AdPrototypeListCard;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdPrototypeListCard.js